interface ProgressBarProps {
  value: number // 0-100
  animated?: boolean
  size?: 'sm' | 'md'
  showLabel?: boolean
}

export function ProgressBar({ value, animated = false, size = 'md', showLabel = false }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value))

  const heightClass = size === 'sm' ? 'h-1' : 'h-2'

  // Design system: progress bars map to Primary (#254F71), Secondary (#94C8E4), Tertiary (#C22221)
  const colorClass =
    clamped === 100
      ? 'bg-success'
      : clamped >= 50
        ? 'bg-primary dark:bg-secondary'   // secondary "pops" in dark mode
        : clamped >= 20
          ? 'bg-warning'
          : 'bg-error'

  return (
    <div className="flex items-center gap-2">
      {/* Track — container-level tonal (no gray-200 hardcode) */}
      <div className={`flex-1 bg-container-light dark:bg-container-dark rounded-full ${heightClass} overflow-hidden`}>
        <div
          className={`${heightClass} rounded-full transition-all duration-500 ${colorClass} ${animated ? 'animate-pulse' : ''}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-xs text-subtle-light dark:text-subtle-dark w-10 text-right tabular-nums">
          {clamped}%
        </span>
      )}
    </div>
  )
}
